module.exports = __webpack_public_path__ + "img/Sample_Certificate_IC3.0efdc7eb.png";